export default function(value: unknown) {
    const _value = String(value || '').toUpperCase();
    return _value === 'FN' || _value === 'FORTNITE';
}
